import React, { Component } from 'react';
import { Dropdown, Modal, Button } from 'semantic-ui-react';
import axios from 'axios'
import { SeeResultsTab } from './SeeResultsTab';
import { Grid } from 'semantic-ui-react'
import { style } from 'd3';

// const SeeResultsTab = () => <div> see results goes here. </div>

class PollsTest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tab: "Send Polls",
            anonymous: true,
            addChoices: false,
            pollDetail: {
                question: "",
                audience: [],
                startDate: "",
                endDate: "",
                choice: [
                    "",
                    ""
                ],
            },
            pollType: "Multiple Choice",
            teams: [],
            selectedTeams: [],
            pollReqSent: false,
            pollSentModal: false
        }

        this.formEdit = this.formEdit.bind(this)
    }

    async formEdit(pollDetailEdit) {
        console.log('reset to this = ', pollDetailEdit)
        const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
        this.resetPollForm()
        this.setState({
            pollDetail: {
                question: pollDetailEdit.question,
                audience: pollDetailEdit.teams,
                pollType: "mul",
                startDate: pollDetailEdit.startDate,
                endDate: pollDetailEdit.endDate,
                choice: pollDetailEdit.choices.map(ch => ch.description)
            }, tab: "Send Polls"
        })
        console.log('state now = ', this.state)
        await axios.post(baseURL + '/poll/delete', { id: pollDetailEdit._id }).then(response => console.log(response)).catch(error => console.log("error deleting polls"))

    }

    async componentDidMount() {
        const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
        const accessToken = localStorage.getItem('accessToken');
        let API = axios.create({ baseURL, headers: { 'Authorization': `Bearer ${accessToken}` }, });

        const response = await API.post(`/fetch-teams`, {}).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        // console.log(response.data.data)
        var teams = [{ name: "All", _id: "All" }, ...response.data.data]
        this.setState({ teams })

    }

    // renderTeamOptions = () => {
    //     console.log(this.state.teams)
    //     return this.state.teams.map(team => <option value={team.name}>{team.name}</option>)
    // }

    SendPollTab = () => {
        let anonymousClass = this.state.anonymous ? "anonymous-button on" : "anonymous-button"
        console.log(this.state)
        const date = (new Date().getFullYear()) + '-0' + (new Date().getMonth() + 1) + '-' + (new Date().getDate())
        console.log("Today's Date = ", date)
        var color1 = this.state.pollDetail.question.length > 280 ? "red" : "grey"
        return (
            <div style={{width: '100%', flexDirection: 'row', display: 'flex'}}>
                <div style={{width: '70%'}}>
                    <form onSubmit={(e) => this.handleAddCoices(e)} style={{ width: '100%' }}>
                        <div style={{ fontWeight: "bold" }}> Ask a Question:</div>

                        <textarea required type="text" placeholder="Type something" id="poll-question" value={this.state.pollDetail.question} onChange={(e) => this.setState({ ...this.state, pollDetail: { ...this.state.pollDetail, question: e.target.value } })}>
                        </textarea>

                        <div style={{ marginLeft: "88%", color: color1 }}>{280 - this.state.pollDetail.question.length}/280</div>

                        <Grid columns={2} >
                            <Grid.Column>
                                <div style={{ fontWeight: "bold" }}> Audience</div>
                                <div className="audience-poll">
                                    <Dropdown
                                        placeholder='For Teams'
                                        multiple
                                        fluid
                                        search
                                        selection
                                        className="teamDropDown"
                                        options={this.state.teams.map(x => {
                                            return {
                                                key: x.name,
                                                value: x._id,
                                                text: x.name,
                                            }
                                        })}
                                        onChange={(t, d) => {
                                            console.log("dd change =", d.value)
                                            if (d.value.includes("All")) {
                                                this.setState({ selectedTeams: this.state.teams.map(item => item._id).slice(1, -1) })

                                            }
                                            else {
                                                this.setState({ selectedTeams: d.value })
                                            }
                                        }}
                                    // value={selectedTeams}
                                    />

                                </div>
                            </Grid.Column>
                            <Grid.Column>
                                <div style={{ fontWeight: "bold" }}> Poll type</div>
                                <div className="audience-poll">
                                    <Dropdown
                                        placeholder='Multiple Choice'
                                        single
                                        fluid
                                        search
                                        selection
                                        className="teamDropDown"
                                        options={[{ key: 1, value: "Multiple Choice", text: "Multiple Choice" }, { key: 2, value: "ENPS", text: "ENPS" }]}
                                        // value={selectedTeams}
                                        onChange={(t, d) => { this.setState({ pollType: d.value }) }}
                                    />

                                </div>
                            </Grid.Column>
                        </Grid>

                        <Grid columns={1} padded>
                            <Grid.Column>
                                <div style={{ display: 'flex' }}>
                                    <div className="poll-date-text" style={{ maxWidth: 'max-content' }}>
                                        <div style={{ fontWeight: "bold" }}> Start Date</div>
                                        <input required min={date} type="date" placeholder="mm/dd/yyyy" id="poll-question-date" value={this.state.pollDetail.startDate} onChange={(e) => this.setState({ ...this.state, pollDetail: { ...this.state.pollDetail, startDate: e.target.value } })}></input>
                                    </div>
                                    <div className="poll-date-text" style={{ maxWidth: 'max-content' }}>
                                        <div style={{ fontWeight: "bold" }}> End Date</div>
                                        <input required type="date" placeholder="mm/dd/yyyy" id="poll-question-date" value={this.state.pollDetail.endDate} onChange={(e) => this.setState({ ...this.state, pollDetail: { ...this.state.pollDetail, endDate: e.target.value } })}></input>
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid>

                        {/* <div className="audience-poll">
                            <div style={{ fontWeight: "bold" }}> Audience</div>
                            <div style={{ marginLeft: "35%", fontWeight: "bold" }}> Poll type</div>
                        </div> */}
                        {/* change */}
                        <div className="audience-poll">
                            <div className="audience-container">
                                {/* <Dropdown

                                    placeholder='For Teams'
                                    multiple
                                    fluid
                                    search
                                    selection
                                    className="teamDropDown"
                                    options={this.state.teams.map(x => {
                                        return {
                                            key: x.name,
                                            value: x._id,
                                            text: x.name,
                                        }
                                    })}
                                    onChange={(t, d) => {
                                        console.log("dd change =", d.value)
                                        if (d.value.includes("All")) {
                                            this.setState({ selectedTeams: this.state.teams.map(item => item._id).slice(1, -1) })

                                        }
                                        else {
                                            this.setState({ selectedTeams: d.value })
                                        }
                                    }}
                                // value={selectedTeams}
                                /> */}
                                {/* <button className={anonymousClass} id="anonymous-button" onClick={()=>this.setState({anonymous: !this.state.anonymous})}>Anonymous</button> */}
                            </div>
                            <div className="audience-container1">
                                {/* 
                            <select required value={this.state.pollDetail.pollType} type="text" placeholder=">tyuu" id="poll-question-type" onChange={e => this.setState({ ...this.state, pollDetail: {...this.state.pollDetail, pollType: e.target.value }})}>
                                <option value="score">Employee Net Promotor Score</option>
                                <option value="mul">Multiple Choice</option>
                            </select> */}
                                {/* <Dropdown

                                    placeholder='Multiple Choice'
                                    single
                                    fluid
                                    search
                                    selection
                                    className="teamDropDown"
                                    options={[{ key: 1, value: "Multiple Choice", text: "Multiple Choice" }, { key: 2, value: "ENPS", text: "ENPS" }]}
                                    // value={selectedTeams}
                                    onChange={(t, d) => { this.setState({ pollType: d.value }) }}
                                /> */}
                            </div>
                        </div>

                        {/* <div className="poll-date">
                            <div className="poll-date-text">
                                <div style={{ fontWeight: "bold" }}> Start Date</div>
                                <input required min={date} type="date" placeholder="mm/dd/yyyy" id="poll-question-date" value={this.state.pollDetail.startDate} onChange={(e) => this.setState({ ...this.state, pollDetail: { ...this.state.pollDetail, startDate: e.target.value } })}></input>
                            </div>
                            <div className="poll-date-text">
                                <div style={{ fontWeight: "bold" }}> End Date</div>
                                <input required type="date" placeholder="mm/dd/yyyy" id="poll-question-date" value={this.state.pollDetail.endDate} onChange={(e) => this.setState({ ...this.state, pollDetail: { ...this.state.pollDetail, endDate: e.target.value } })}></input>
                            </div>
                        </div> */}


                        {/* <div> */}
                        {this.state.pollType === "Multiple Choice" ? this.choicesTabCont() : <div>A range of 0-10 will be the poll choices.</div>}
                        {/* <div style={{color: "black", fontSize: "14px", fontWeight: "bold"}}>Add Choices</div>
                        <div className="add-choice-cont" >{this.addChoicesTab()}</div> */}


                        <div className="button-choices" style={{ justifyContent: 'center' }}>
                            <button className="cancel-button" style={{
                                float: 'inline-end',
                                marginRight: '5%'
                            }} onClick={() => this.setState({ addChoices: false })}>Cancel</button>
                            <button className="add-choices-button" style={{
                                marginLeft: 0,
                                float: 'inline-end',
                                marginRight: 20
                            }} disabled={
                                this.state.pollType === 'Multiple Choice' ?
                                    this.state.pollDetail.question.length === 0 ||
                                    this.state.selectedTeams.length === 0 ||
                                    this.state.pollDetail.startDate.length === 0 ||
                                    this.state.pollDetail.endDate.length === 0 ||
                                    this.state.pollDetail.choice[0].length === 0 ||
                                    this.state.pollDetail.choice[1].length === 0 :

                                    this.state.pollType === 'ENPS' ?

                                        this.state.pollDetail.question.length === 0 ||
                                        this.state.selectedTeams.length === 0 ||
                                        this.state.pollDetail.startDate.length === 0 ||
                                        this.state.pollDetail.endDate.length === 0 : false

                            } onClick={this.state.pollReqSent ? null : this.submitPollData}>Send Poll</button>
                            {console.log(this.state.pollDetail.audience.length)}
                        </div>
                        {/* </div> */}
                        <div className="button-choices">
                            {/* <button className="cancel-button" onClick={() => window.location.reload(false)}>Cancel</button> */}
                            {/* <button className="add-choices-button" type="submit">Add Choices</button> */}

                        </div>
                    </form>
                </div>
                <div style={{width: '30%'}}>
                    
                </div>
            </div>
        )
    }

    enpsTab() {
        let enps = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
        this.setState({ ...this.state, pollDetail: { ...this.state.pollDetail, choice: enps } })
        return <div>A range of 0-10 will be the poll choices.</div>
    }
    choicesTabCont = () => {
        return (
            <div>
                <div style={{ color: "black", fontSize: "14px", fontWeight: "bold" }}>Add Choices</div>
                <div className="add-choice-cont" >{this.addChoicesTab()}</div>
            </div>
        )
    }
    handleAddCoices = (e) => {
        console.log(e)
        e.preventDefault()
        this.setState({ addChoices: true })
    }
    addChoicesCont() {
        var btnTxt = this.state.pollReqSent ? 'Sending Poll ...' : 'Send Poll'
        return (
            <div className="one">
                <div className="two" style={{ color: "black", fontSize: "18px" }}>Add Choices</div>
                {this.addChoicesTab()}

                <div className="button-choices">
                    {/* <button className="cancel-button" onClick={() => this.setState({addChoices: false})}>Cancel</button> */}
                    <button className="add-choices-button" onClick={this.state.pollReqSent ? null : this.submitPollData}>{btnTxt}</button>

                </div>
            </div>
        )
    }

    updateChoice(e) {
        var i = e.target.dataset.choicenum2
        var newState = { ...this.state }
        newState.pollDetail.choice[i] = e.target.value
        this.setState(newState)
    }

    addChoiceInput = (e) => {
        console.log("add section")
        var newState = this.state
        if (newState.pollDetail.choice.length < 6) {
            newState.pollDetail.choice.push("")
            this.setState(newState)
        }
    }

    removeChoiceInput = (e) => {
        // cope to new var
        console.log("remove section")
        var newState = this.state
        console.log("remove state1  = ", newState)
        console.log("remove data  = ", e.target.dataset.choicenum)
        // remove selected
        var a = newState.pollDetail.choice.filter((item, index) => {
            console.log("index = ", index)
            console.log("target = ", e.target.dataset.choicenum)
            return index != e.target.dataset.choicenum
        })
        console.log("A = ", a)
        newState.pollDetail.choice = a
        // update state
        console.log("remove state  = ", newState)
        this.setState(newState)
    }

    addChoicesTab() {
        var choices = this.state.pollDetail.choice

        return choices.map((ch, i) => {
            var icon = i === choices.length - 1 ? "+" : "x"
            var updateFn = i === choices.length - 1 ? this.addChoiceInput : this.removeChoiceInput
            return (
                <div className="add-choice-field">
                    <input value={ch} id="poll-question-audience" type="text" data-choicenum2={i} placeholder={"Choice " + (i + 1)} onChange={e => this.updateChoice(e)} />
                    <div
                        data-choicenum={i}
                        style={{ fontSize: "18px", marginTop: "15px", marginLeft: "10px" }}
                        onClick={e => updateFn(e)}
                    >
                        {icon}
                    </div>
                </div>
            )
        })
    }

    submitPollData = async () => {
        console.log('here')
        // this.setState({ pollReqSent: true })
        let enps = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
        var enpsChoices = enps.map(choice => {
            return {
                description: choice,
                totalVotes: 0
            }
        })
        var choices = this.state.pollDetail.choice.map(choice => {
            return {
                description: choice,
                totalVotes: 0
            }
        })
        var token = localStorage.getItem('accessToken')
        const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
        console.log("baseURL = ", baseURL)
        var result = await axios.post(baseURL + '/poll/add', {
            "teamName": this.state.selectedTeams,
            "question": this.state.pollDetail.question,
            "anonymous": this.state.anonymous,
            "pollType": this.state.pollType,
            "startDate": this.state.pollDetail.startDate,
            "endDate": this.state.pollDetail.endDate,
            "choices": this.state.pollType === "Multiple Choice" ? choices : enpsChoices,
            "totalLikes": 0
        }, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
        if(result.status === 200){
            this.setState({pollSentModal: true})
        }

        await axios.post('http://localhost:8080/slack/message', {
            email: "abelp915@gmail.com",
            message: "A new poll has been pushed, please take the poll on your mobile app"
        })
        await axios.post(baseURL + '/recentActions', { task: 'A New Poll is added' }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem('accessToken')
            }
        })

        // this.setState({ pollReqSent: false })
        this.resetPollForm()
        console.log(result)
    }
    resetPollForm = () => {
        this.setState({
            addChoices: false,
            pollDetail: {
                question: "",
                audience: "",
                pollType: "mul",
                startDate: "",
                endDate: "",
                choice: [
                    "",
                    ""
                ],
            },
        })

    }



    render() {
        console.log(this.state)
        let sendPollTab = this.state.tab === "Send Polls" ? "active" : "not-active"
        let seeResultTab = this.state.tab === "See Results" ? "active" : "not-active"
        return (
            <div>
                <div className="zero" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                    <div className="poll-result-tab">
                        <div className={sendPollTab} style={{ textAlign: 'center', color: "black", marginRight: "10px", fontSize: "13px" }} onClick={() => this.setState({ tab: "Send Polls" })}>Send Polls</div>
                        <div className={seeResultTab} style={{ textAlign: 'center', color: "black", fontSize: "13px" }} onClick={() => this.setState({ tab: "See Results" })}>See Results</div>
                    </div>
                    {this.state.tab === "Send Polls" ? this.SendPollTab() : <SeeResultsTab formEdit={this.formEdit} />}
                    {/* {this.state.tab === "Send Polls" ? !this.state.addChoices ? this.SendPollTab() : this.addChoicesCont() : <SeeResultsTab formEdit={this.formEdit} />} */}
                </div>
                <Modal dimmer={'blurring'} open={this.state.pollSentModal} size="mini">
                    <Modal.Content><p>Poll Sent Successfully</p></Modal.Content>
                    <Modal.Actions className="center aligned"><Button onClick={e => this.setState({pollSentModal: false})}>Ok</Button></Modal.Actions>
                </Modal>
            </div>
        );
    }
}

export default PollsTest;
